import { useTranslation } from "react-i18next";
import { ExtraWorkAgreementInitialStatus, GetProjectResponse, usePostApiProjectsByProjectIdExtraworkagreementsMutation } from "api/generatedApi";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { ExtraWorkAgreementFormData } from "./use-input-validation";
import { useGetApiConfigQuery } from "api/generatedApi";
import { UploadDocument } from "shared/editors/hooks/upload-document";

interface Props {
  project: GetProjectResponse;
  tempFilesforUpload?: File[];
}

export function useCreateExtraWorkAgreement(props: Props) {
  const { project, tempFilesforUpload } = props;
  const { t } = useTranslation();
  const { data: configData } = useGetApiConfigQuery();
  const uploadDocument = UploadDocument("", configData?.maxUploadFileSizeMB);

  const [createExtraWorkAgreement] = usePostApiProjectsByProjectIdExtraworkagreementsMutation();

  const wrapMutation = useMutation({
    onSuccessReponse(response) {
      const uploadPath = `/api/projects/${project.id}/extraworkagreements/${response}/documents`;
      for (const file of tempFilesforUpload ?? []) {
        uploadDocument(file, uploadPath);
      }
    },
    successProps: {
      description: t("dashboard.extraWorkAgreements.create.success.description"),
    },
    errorProps: {
      description: t("dashboard.extraWorkAgreements.create.error.description"),
    },
    resultDialogType: ResultDialogType.Toast,
  });

  const handleOnSubmit = async (data: ExtraWorkAgreementFormData, initialStatus: ExtraWorkAgreementInitialStatus) => {
    const result = await wrapMutation(
      createExtraWorkAgreement({
        projectId: project?.id ?? "",
        createExtraWorkAgreementRequest: {
          description: data.description,
          extraWorkAgreementNumber: data.extraWorkAgreementNumber,
          extraWorkAgreementType: data.extraWorkAgreementType,
          name: data.name,
          paymentDkr: data.extraWorkAgreementType === "AgreedPayment" ? data.paymentDkr : undefined,
          workTime: data.extraWorkAgreementType === "CompanyHours" || data.extraWorkAgreementType === "CustomerHours" ? data.workTime : undefined,
          isPrivate: data.isPrivate,
          initialStatus: initialStatus,
        },
      })
    );

    // Return the created agreement data
    return result;
  };

  return handleOnSubmit;
}
